import React, { Component } from 'react'

import style from './Grid.css'

export default class Row extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={`${style.Row} ${this.props.className || ''}`}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Grid/Row.js